import { NavigationGuard } from "vue-router"
import router from "@/router"
import { useEnrollmentStore } from "@/store/enrollment-new-store"

export const ensureCurrentPendingEnrollmentIdPresence: NavigationGuard = (_to, _from, _next) => {
  const enrollmentStore = useEnrollmentStore()

  if (!enrollmentStore.currPendingEnrollmentId) {
    router.push({ name: "home" }).then()
    return false
  }

  return true
}

export const ensureCurrentPendingEnrollmentBenefitPlansWithTiersPresence: NavigationGuard = (_to, _from, _next) => {
  const enrollmentStore = useEnrollmentStore()

  if (!enrollmentStore.currPendingEnrollment) {
    router.push({ name: "enrollment-landing", query: router.currentRoute.value.query }).then()
    return false
  }

  return true
}

export const ensureCurrentPendingEnrollmentSelectedPlanTierPresence: NavigationGuard = (_to, _from, _next) => {
  const enrollmentStore = useEnrollmentStore()

  if (!enrollmentStore.currPendingEnrollmentSelectedPlanTiers.length) {
    router.push({ name: "enrollment-landing", query: router.currentRoute.value.query }).then()
    return false
  }

  return true
}
